import React from 'react';
import { useTranslation } from 'react-i18next';

const Dashboard = () => {
  const { t } = useTranslation();
  
  // 移除了資料獲取和處理邏輯

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-6">
        <h1 className="text-2xl font-bold text-purple-600 dark:text-purple-400 mb-4">{t('dashboard')}</h1>
        <p className="text-gray-600 dark:text-gray-300 mb-4">{t('welcomeToDashboard')}</p>
        <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {t('dashboardDescription')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
